import * as angular from 'angular';
import * as _ from 'lodash';
import ComponentController from '../../../common/components/component-controller';
var templateUrl = require('./subscriptionDetail.html');

class SubscriptionDetailController extends ComponentController {
  readonly subscriptionTypes: any[] = [
    { id: 'EpxReportSubscription', name: 'EPX Reports' },
    { id: 'EpxAlarmSubscription', name: 'EPX Alarms' }
  ];
  canDelete: boolean;
  subscription: any;
  currentSite: any;

  constructor(
    private $state: any,
    private SubscriptionService: any,
    private AuthService: any,
    private uibModal: any
  ) {
    super();
  }

  $onInit = () => {
    if (!this.subscription.site.id) {
      this.subscription.site = this.currentSite;
    }
    this.canDelete =
      this.subscription.id && this.AuthService.hasPermission('Subscription', 'destroy');
  };

  saveSubscription = () => {
    this.subscription.deliveryMethod = 'email';
    this.SubscriptionService.save(this.subscription).then(() => {
      this.goToSubscriptions();
    });
  };

  deleteResource = () => {
    this.SubscriptionService.delete(this.subscription).then(() => {
      this.goToSubscriptions();
    });
  };

  confirmDelete = () => {
    this._confirmDelete(this.uibModal, this.subscription, this.subscription.recipient);
  };

  goToSubscriptions = () => {
    this.$state.go('app.epx.subscriptions');
  };
}

angular.module('ciApp').component('epx.subscriptionDetail', {
  templateUrl: templateUrl,
  bindings: {
    subscription: '<',
    currentSite: '<'
  },
  controller: [
    '$state',
    'SubscriptionService',
    'AuthService',
    '$uibModal',
    SubscriptionDetailController
  ]
});



// WEBPACK FOOTER //
// ./app/epx/subscriptions/subscriptionDetail.component.ts